import { LotteryConfigModel } from "../models/lottery-configuration-model";
import { Lottery } from "../../../models/lottery";

export const euromilionyConfig: LotteryConfigModel = {
    lottery: Lottery.euromiliony,
    boardCount: 9,
    primaryBoardSize: 7,
    defaultStake: 0,
    defaultStakeKasa: 3000,
    primaryNumbers: 35,
    basePrice: 30,

    secondaryBoardSize: 1,
    secondaryNumbers: 5,

    addonBoardSize: 5,
    addonNumbers: 9,
    addonPrice: 30,

    primarySystemMinCount: 7,
    primarySystemDefaultCount: 8,
    primarySystemMaxCount: 13,
    secondarySystemMinCount: 1,
    secondarySystemDefaultCount: 1,
    secondarySystemMaxCount: 5,

    boardLabel: "Sloupec",
    hasDurationComponent: true,
    hasDrawOptions: false,
    hasMultidrawNotification: true,
    hasAllOrOneMultidrawOptions: false,
    hasSubscription: true,
    hasCalculatedJackpot: false,

    isDrawnEveryDay: false,
    durationTitle:
        "Euromiliony se hrají pravidelně <strong>2x&nbsp;týdně</strong>, vždy v <strong>úterý</strong> a v <strong>sobotu</strong>.",
    durationTitleShort: "Euromiliony se hrají pravidelně 2x týdně, vždy v úterý a v sobotu.",
    maxDuration: 16,
    multidrawDurationOptions: [
        { value: "tue", valueKasa: "TUESDAY", mainText: "Úterý", dayOfWeek: 2, hour: 19, drawName: "tue" },
        { value: "sat", valueKasa: "SATURDAY", mainText: "Sobota", dayOfWeek: 6, hour: 19, drawName: "sat" },
    ],
};
